
import { PropType, ref, defineComponent } from "vue";
import { YObject } from "@/types";
import { yReactive } from "@/util";
import { changeTodoText, setDone as _setDone, Todo, deleteTodo } from "@/store/todo";

export default defineComponent({
  name: "Todo",
  components: {},
  props: {
    todo: { type: Object as PropType<YObject<Todo>>, required: true },
    index: { type: Number, required: true },
  },
  setup(props) {
    const todoRef = yReactive(props.todo);

    const editing = ref(false);
    const todoTxt = ref(props.todo.get("text"));

    function setDone(e: Event, index: number) {
      const target = e.target as HTMLInputElement;
      _setDone(index, target.checked);
    }

    function toggleEdit() {
      if (editing.value === true && props.todo.get("text") !== todoTxt.value) {
        changeTodoText(props.index, todoTxt.value);
      }
      editing.value = !editing.value;
    }

    return { todoRef, editing, todoTxt, setDone, toggleEdit, deleteTodo };
  },
});
